import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { SignInForm } from './SignInForm';
import { readResume, useAuth } from '@/app/auth';
import { workspaceLanding } from '@/app/workspaces';
import { API_MODE } from '@/app/config';

const DEMO = [
  { username: 'dr.patel', label: 'Provider' },
  { username: 'nurse.kim', label: 'Nurse / MA' },
  { username: 'desk.lopez', label: 'Front desk' },
  { username: 'billing.okafor', label: 'Revenue / HIM' },
  { username: 'privacy.reyes', label: 'Privacy & compliance' },
  { username: 'admin.chen', label: 'Tenant admin' },
  { username: 'dr.multi', label: 'Provider + admin' },
  { username: 'ops.root', label: 'Platform operator' },
  { username: 'dr.harbor', label: 'Provider (Harbor tenant)' },
];

/** Workforce sign-in. Patients are sent to the portal entry. */
export default function LoginPage() {
  const { status, me } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.title = 'Sign in · ETNAS';
  }, []);

  if (status === 'signed-in' && me) {
    if (me.user.kind === 'patient') return <Navigate to="/portal" replace />;
    return <Navigate to={workspaceLanding(me.context.roleId, me.context.role.key)} replace />;
  }

  return (
    <main className="ex-auth" id="main">
      <div className="ex-auth-card">
        <div className="ex-auth-brand">
          <span className="ex-rail-mark" aria-hidden="true">E</span>
          <div>
            <div className="ex-strong">ETNAS</div>
            <div className="ex-caption ex-fg-muted">Clinical workspace {API_MODE === 'mock' ? '· synthetic data' : ''}</div>
          </div>
        </div>
        <SignInForm
          demoUsers={DEMO}
          onSignedIn={() => {
            // Resume to the same place for the same person (reload, crash, timeout) — never across people.
            const r = readResume();
            const from = (location.state as { from?: string } | null)?.from;
            navigate(from ?? '/', { replace: true, state: { resume: r } });
          }}
        />
        <p className="ex-caption ex-fg-muted" style={{ margin: 0 }}>
          Patients and family members: <a href="/portal/login">sign in to the patient portal</a>.
        </p>
      </div>
    </main>
  );
}
